import React from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell } from "@shared/components";
import { AgreementPlan } from "@modules/agreementPlans/types";
import { Button } from "@mui/material";

export const useLandingsListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  agreements?: AgreementPlan[]
): GridColDef[] => {
  const renderETCell = (params: GridRenderCellParams) => {
    const { row } = params;
    const typeurl =
      row.type === "bookstore" ? ".ebooks.app.br" : ".partiu.com.br";
    const url = row.slug ? `https://${row.slug}${typeurl}` : "#";
    return (
      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          row.slug && window.open(url, "_blank");
        }}
        disabled={!row.slug}
      >
        {translate("buttons.access")}
      </Button>
    );
  };

  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("v1/landing_admin.table.id"),
        width: 80,
      },
      {
        field: "slug",
        headerName: translate("v1/landing_admin.table.slug"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text value={value} textAlign="left" />
        ),
      },
      {
        field: "agreement",
        headerName: translate("v1/landing_admin.table.agreement"),
        minWidth: 250,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/agreement/edit/${value}`}
            value={
              agreements?.find((agreement) => agreement.id === value)?.name
            }
          />
        ),
      },
      {
        field: "et",
        headerName: translate("v1/landing_admin.fields.access"),
        minWidth: 160,
        headerAlign: "center",
        align: "center",
        renderCell: renderETCell,
      },
      {
        field: "created_at",
        headerName: translate("v1/landing_admin.table.createdAt"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Date value={value} align="center" />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <>
            <EditButton hideText recordItemId={row.id} />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </>
        ),
      },
    ],
    [translate, onRefetch, agreements]
  );
};
